@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.appSettings

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint

object PostOtaStatsLogEndpoint : EndPoint<Array<PostOtaStatsLogEndpoint.Event>, PostOtaStatsLogEndpoint.Response>() {

    @Suppress("PropertyName", "ConstructorParameterNaming")
    class Event(
        @Suppress("NON_EXPORTABLE_TYPE") val platform: DtoName<Platform>,
        val device_id: String?,
        val app_id: String?,
        val action: String?,
        val version_name: String?,
        val custom_id: String?,
        val version_build: String?,
        val version_code: String?,
        val version_os: String?,
        val plugin_version: String?,
        val is_emulator: Boolean,
        val is_prod: Boolean,
        val channel: String?,
        val defaultChannel: String?,
        val old_version_name: String?,
        val key_id: String?,
        @Suppress("NON_EXPORTABLE_TYPE") val timestamp: Long?,
    )

    class Response(
        @Suppress("NON_EXPORTABLE_TYPE") val results: List<EventResult>,
    )

    class EventResult(
        val status: String,
        val deviceId: String,
        val action: String,
    )
}
